import { render, staticRenderFns } from "./SocTableItem.vue?vue&type=template&id=21f0f8f2&lang=pug"
import script from "./SocTableItem.vue?vue&type=script&lang=ts"
export * from "./SocTableItem.vue?vue&type=script&lang=ts"
import style0 from "./SocTableItem.vue?vue&type=style&index=0&id=21f0f8f2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports